var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 439.5 345.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M439.5,344.7h0L247.3,0H103.2l107.4,208.6c45.6,83.9,133.4,136.1,228.9,136.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    y: 152.1,
    width: 154.9,
    height: 193.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoApp);
export default __webpack_public_path__ + "static/media/logo-app.f5c5f94be29975f18478d82510696c9c.svg";
export { ForwardRef as ReactComponent };